export default "__VITE_ASSET__CCzlAJxO__"